import { ChevronLeftRounded, ChevronRightRounded, Height } from '@mui/icons-material';
import { Chip, Divider, Grid, IconButton, Stack, Typography,Box, CircularProgress, Tabs,Tab, Button, Skeleton } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useCategories } from '../../hooks/useCategories';
import useDevice from '../../hooks/useDevice';
import { useSearchCourse } from '../../hooks/useSearchCourse';
import BundleCard from '../../components/bundlecard/bundlecard';
import ProgramCard from '../../components/programcard/ProgramCard';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useRouter } from 'next/router';
import CarouselArrows from '../../components/carousel/CarouselArrows'
import NoDataComponent from '../../components/nodata/nodata';
import { getString } from '../../functions/getString';
import ProgramCardSkeleton from '../../components/programcard/ProgramCardSkeleton';

const Nodata =()=>{
    return(
        <Box pt={3} display={"contents"}  justifyContent={"center"}>

              <NoDataComponent
                    title={getString('You have no courses enrolled')}
                    description={
                        <Stack direction={'row'} gap={1} alignItems={'center'} justifyContent={'center'} >
                           
                        </Stack>
                    }
                />
        </Box>
    )
   
    }


const CustomCategoryListing2= ({item, ...props}) => {
    
    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { reducer } = useSelector((state) => state);
    const { headers, pageJson, isSiteBuilder } = reducer || {};

    const {replace} = useRouter();
    const LIMIT = 10;

    const [allCategories, setAllCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [categoryLoading, setCateggoryLoading] = useState(true)
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [tabValue, setTabValue]  = useState("courses")
    const [count, setCount] = useState(0)
    const [currentCategoryCourses, setCurrentCategoryCourses] = useState({
        data: [],
        // bundles: []
    })

   

    const getCategoryData = async () => {
        const result = await useCategories()
        setAllCategories(result)
        if(result?.length > 0)
        {
            setSelectedCategory(result[0])
        }
        
    }

    useEffect(() => {
        getCategoryData()
    }, []);

    const getCategoryPrograms = async () => {
        if (selectedCategory?.id) { // check if selected category exists
            setIsLoading(true);
            const result = await useSearchCourse(headers, `${''}&direction=${'asc'}&order_by=item_name&category_ids=${selectedCategory.id}&type=${tabValue}&limit=${LIMIT}`)
            const totalCount = result?.total_data
            setCount(totalCount);
            setCurrentCategoryCourses(result)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (!isSiteBuilder){
            getCategoryPrograms()
        }
    }, [selectedCategory?.id, tabValue])

    const scrollRef = useRef(null);
    const scrollRef1 = useRef(null);
    
    const programCardScroll = (scrollOffset) => {
        return scrollRef ? (scrollRef.current.scrollLeft += scrollOffset) : null;
    };
    const programCardScroll1 = (scrollOffset) => {
        if (scrollRef1) {
          const scrollNode = scrollRef1.current;
          const currentScrollLeft = scrollNode.scrollLeft;
          const newScrollLeft = currentScrollLeft + scrollOffset;
          scrollNode.scrollTo({
            left: newScrollLeft,
            behavior: 'smooth'
          });
        }
      };

    const { isMobile, isTablet } = useDevice();
    const categories = ["Web Development", "Mobile App Development", "Sales & Communication", "Personal Development", "DevOps Deployment and Infrastructure Automation", "Blockchain Technology","Intelligent Hardware Development"]

    return (
        <Stack p={2}>

            <Box sx={{ display:isSmScreen ? "none" : "flex" }} justifyContent={'flex-end'} >
                
                <CarouselArrows
                    customIcon={'ic:round-keyboard-arrow-right'}
                    onNext={() => { programCardScroll1(500) }}
                    onPrevious={() => { programCardScroll1(-500) }}
                    sx={{ '& .arrow': { width: 28, height: 28, p: 0,}}}
                    
                />    
            </Box> 

            {
                <>
                        <Stack direction={'row'} gap={1} sx={{ overflowX: 'auto' , paddingTop:isSmScreen ? "10px" : "" }} divider={<Divider orientation='vertical' flexItem  />}  ref={scrollRef1}>
                        {isSiteBuilder && 
                            <>
                                <Stack direction={'row'} gap={1} sx={{ overflowX: 'auto' , paddingTop:isSmScreen ? "10px" : "" }} divider={<Divider orientation='vertical' flexItem  />}  ref={scrollRef1}>
                                    {categories.map((cat, index) => (
                                        <Chip key={index} label={cat} />
                                    ))}

                                </Stack>
                            </>
                   
                        }
                    
                        {!isSiteBuilder &&
                            allCategories?.map((item, index) => {
                                const isSelected = item?.id == selectedCategory?.id
                                return (
                                <Chip 
                                        label={item?.ct_name} 
                                        sx={{ 
                                            borderRadius: 1, 
                                            bgcolor: isSelected ? `${theme?.palette?.primary?.main}` : undefined, 
                                            color: isSelected ? '#fff' : undefined ,
                                            padding: isSmScreen ? "" : "25px" ,
                                            fontWeight: isSmScreen ? "" : "bolder" ,
                                            fontSize:isSmScreen ? "" : "17px" ,
                                            border:`solid 1px ${theme?.palette?.primary?.main}`,
                                            '&:hover': {
                                                backgroundColor:`${theme?.palette?.primary?.light}`
                                                    }

                                        }} 
                                        onClick={() => {
                                            setSelectedCategory(item)
                                        }}
                                    
                                    />
                                )
                            })
                        }
                    </Stack> 
                    
                    <Stack sx={{padding:isMobile ? "2px" : 3}} border={1} borderColor={'divider'} mt={2} justifyContent={'center'} position={'relative'} gap={5}>

                        <Tabs
                            value={tabValue}
                            onChange={(e, newValue) => setTabValue(newValue)}
                            sx={{
                                "& .MuiTabs-flexContainer": 
                                    {
                                        gap: "8px",
                                        borderBottom :"1px solid #ddd",
                                    },
                                "& .MuiTab-root":
                                    {
                                        fontSize: "0.95rem",
                                        padding: "10px 20px",
                                        borderRadius: "8px 8px 0 0", 
                                        color: "primary.main",
                                    },
                                "& .Mui-selected": 
                                    {
                                        color: "black",
                                        border: "1px solid #ddd",
                                        borderBottom: "none", 
                                        fontWeight: 600,
                                    },
                                }}
                            >
                            <Tab 
                                value ='courses' 
                                label={
                                    <span
                                        data-sb-label="courses"
                                        contentEditable={isSiteBuilder}
                                    >
                                        {item?.props?.coursesLabel ?? "Course"}
                                    </span>
                                }
                            />
                            <Tab 
                                value ="bundles" 
                                label={
                                    <span
                                        data-sb-label="bundles"
                                        contentEditable={isSiteBuilder}
                                        style={{textTransform:"none"}}
                                    >
                                        {item?.props?.bundlesLabel ?? "Learning paths"}
                                    </span>
                                }
                            />
                        </Tabs>

                        {
                            currentCategoryCourses?.data?.length > 4 &&
                            <Stack
                                sx={{
                                    position: 'absolute',
                                    bgcolor: `${theme?.palette?.primary?.main}`,
                                    left: -20,
                                    borderRadius: 100,
                                    color: '#fff',
                                    cursor: 'pointer'
                                }}
                            >
                                <IconButton sx={{ color: '#fff',display: isSmScreen ? "none" : ""  }} onClick={() => { programCardScroll(-600) }} >
                                    <ChevronLeftRounded/>
                                </IconButton>
                                
                            </Stack>
                        }

                    

                        {
                            currentCategoryCourses?.bundles?.length > 4 &&
                            <Stack
                                sx={{
                                    position: 'absolute',
                                    bgcolor: `${theme?.palette?.primary?.main}`,
                                    right: -20,
                                    borderRadius: 100,
                                    color: '#fff',
                                    cursor: 'pointer',
                                    
                                }}
                            >
                                <IconButton sx={{ color: '#fff' ,display: isSmScreen ? "none" : ""}} onClick={() => { programCardScroll(600) }} >
                                    <ChevronRightRounded/>
                                </IconButton>
                            </Stack>
                        }

                        {/* <Typography variant='h6'sx={{fontSize:isSmScreen ? "16px" : "32px !important"}} >Expand your training opportunities with Accenturre</Typography>
                        <Typography>Choose from 2,000 online video courses with new additions published every month</Typography> */}

                        {
                           !isSiteBuilder &&  isLoading? (
                                <Box sx={{  display :"flex" ,height: "320px", gap:2, overflow:"hidden" }}>
                                    {Array.from({ length: 5}).map((_, index) => (
                                        <>
                                            <Stack>
                                                <Skeleton key={index} width={400} height={300} />
                                                <Skeleton key={index} width={300} height={20} />
                                            </Stack>
                                            
                                        </>
                                        
                                    ))}

                                </Box>

                            ) : (

                                <Stack direction={'row'} gap={2}  overflow={'hidden'} sx={{ overflowX: 'auto', scrollBehavior: 'smooth' }} ref={scrollRef} >

                                    {
                                        !isSiteBuilder && currentCategoryCourses?.data?.map((item, index) =>{   
                                            return(
                                                <Stack width={'100%'} minWidth={250} maxWidth={250} >
                                                    {item.pb_type === "1" || item.pb_type === "3" ? (
                                                        <ProgramCard item={item} index={index} />
                                                    ) : (
                                                        <BundleCard item={item} index={index} />
                                                    )} 
                                                </Stack>
                                            )
                                        })
                                    }
                                     {isSiteBuilder && 
                                        <>
                                            <Grid container spacing={2} >
                                                {
                                                    Array(5).fill(1).map((item,index) =>{
                                                        return(
                                                            <Grid item xl={2.4} lg={3} md={4} sm={6} xs={12}  key={index} mt={3}>
                                                                <ProgramCardSkeleton/>
                                                            </Grid>
                                                        )
                                                    })
                                                }
                                            </Grid>
                                        </>
                                    }
                                    {
                                        !isSiteBuilder && currentCategoryCourses?.data?.length < 1  && !isLoading &&
                                        <Nodata/>
                                    }
                                    {/* {
                                        currentCategoryCourses?.bundles?.map((item, index) =>{   
                                            return(
                                                <Stack width={'100%'} minWidth={250} maxWidth={250} >                                  
                                                    <BundleCard
                                                        item={item}
                                                        index={index}                                       
                                                    />  
                                                                                    
                                                </Stack>
                                            )
                                        })
                                    } */}
                                    

                                </Stack>
                            )
                        }

                        {(count > 10 || isSiteBuilder) &&  <Grid xs={12} textAlign= "center">
                            <Button  
                                component={isSiteBuilder ? "div" : "button"}
                                contentEditable={isSiteBuilder}
                                data-sb-label="show-more"
                                variant="outlined"  
                                size="large"  
                                sx={{borderRadius:"999px", textTransform:"none"}} 
                                onClick={() => !isSiteBuilder &&  replace("/all-courses")}
                                style={{
                                    cursor: isSiteBuilder ? "text" : "pointer",
                                }}
                            >
                                    
                                {item?.props?.showMoreLabel ?? "Show more"}
                            </Button>
                        </Grid>}
                        
                    </Stack>
                </>
            }
            

        </Stack>
    )
};

export default CustomCategoryListing2;